import { generateTypes } from '../utils/HttpReducerHelper';

const companyUsers = generateTypes('COMPANY', 'COMPANY_USERS');

export { companyUsers };
